/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { ButtonSlotProps } from "../types";

export const DefaultButton: React.FC<ButtonSlotProps> = ({
  variant,
  onClick,
  disabled,
  className,
  children,
  ...rest
}) => {
  return (
    <button
      className={`player-default-button ${variant || ""} ${className || ""}`}
      onClick={onClick}
      disabled={disabled}
      type={rest.type}
      title={rest.title}
      aria-label={rest["aria-label"]}
      aria-labelledby={rest["aria-labelledby"]}
      aria-controls={rest["aria-controls"]}
      aria-expanded={rest["aria-expanded"]}
      aria-haspopup={rest["aria-haspopup"]}
    >
      {children}
    </button>
  );
};
